import { Component, Decision, State } from '../structure';

import { getToken } from './getToken';
import { ThemeProps } from './types';

export const getComponentVariableToken =
    <V extends string | number>(componentName: Component, variantPropName: V) =>
    (decision: Decision, { state }: { state?: State } = {}) =>
    (props: { [key in V]?: string | undefined } & ThemeProps) => {
        const variant = props[variantPropName];
        return getToken(props, componentName, decision, { variant, state });
    };
